import React from 'react';

import styled from '@emotion/styled';

import CustomHorizontalBarChat from '../../../components/Charts/CustomHorizontalBarChat';

const GenderAndDriverTypeCharts = () => {
  const genderDynamicsData = [
    { gender: 'Male', value: 54, color: '#5B91F5' },
    { gender: 'Female', value: 20, color: '#073277' },
  ];

  const driverDistributionTypeData = [
    { driverType: 'Gig Drivers', value: 54, color: '#00B73F' },
    { driverType: 'Exclusive Drivers', value: 20, color: '#006105' },
  ];

  return (
    <Container>
      <ChartWrapper>
        <CustomHorizontalBarChat
          leftLabelKey='gender'
          data={genderDynamicsData}
          dataKey={'value'}
          colorKey='color'
          description='Gender Dynamics'
          lineThickness={12}
          roundness={8}
          leftLabelWidth='250px'
          label={{
            fontWeight: '500',
            fontSize: '18px',
            lineHeight: '18px',
            marginBottom: '8px',
          }}
        />
      </ChartWrapper>

      <ChartWrapper>
        <CustomHorizontalBarChat
          leftLabelKey='driverType'
          data={driverDistributionTypeData}
          dataKey={'value'}
          colorKey='color'
          description='Driver type distribution'
          lineThickness={12}
          roundness={8}
          leftLabelWidth='250px'
          label={{
            fontWeight: '500',
            fontSize: '18px',
            lineHeight: '18px',
            marginBottom: '8px',
          }}
        />
      </ChartWrapper>
    </Container>
  );
};

export default GenderAndDriverTypeCharts;

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  width: 100%;
  grid-column: span 3;
`;

const ChartWrapper = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  padding: 24px;
  border-radius: 16px;
`;
